import "@fontsource-variable/inter/index.css";
import "@fontsource-variable/jetbrains-mono/index.css";
import "@fontsource-variable/sora/index.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { queryClientOptions } from "./query-client";
import { router } from "./router";
// Entrada única de estilos: tokens de tema, reset e os layers do Tailwind.
// O preflight e o reset do produto convivem na layer base. Ver tailwind.css e
// docs/design/ui-foundation.md.
import "./tailwind.css";

// Defaults do cache (staleTime/gcTime) vivem em `query-client.ts` para que a
// guarda de regressão os leia sem montar o app. Ver o porquê lá.
const queryClient = new QueryClient(queryClientOptions);

// O QueryClientProvider fica FORA do RouterProvider: os portões da árvore
// (TenantGate) consultam a sessão via react-query já na raiz das rotas.
// TUT-206a: o `ErrorBoundary` fica FORA do roteador e DENTRO do provider de
// consultas. Fora do roteador porque uma exceção de render em qualquer rota
// precisa cair aqui — se ficasse dentro, a própria rota que quebrou levaria a
// rede junto. Dentro do provider porque a tela de erro é conteúdo comum do
// app, e não uma segunda aplicação: mantê-la no mesmo contexto evita que o
// remédio precise de infraestrutura própria.
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ErrorBoundary>
        <RouterProvider router={router} />
      </ErrorBoundary>
    </QueryClientProvider>
  </StrictMode>,
);
